module.exports = __webpack_public_path__ + "static/img/性能检测报告.e8422611.png";